import { clientReducer } from '@features/client/store/client.reducer';
import { ClientState } from '@features/client/store/client.state';
import { researchesReducer } from '@features/researches/store/researches.reducer';
import { ResearchesState } from '@features/researches/store/researches.state';
import * as fromRouter from '@ngrx/router-store';
import { routerReducer } from '@ngrx/router-store';
import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { authReducer } from './auth/store/auth.reducer';
import { AuthState } from './auth/store/auth.state';

export const reducers: ActionReducerMap<AppState> = {
  auth: authReducer,
  researches: researchesReducer,
  client: clientReducer,
  router: routerReducer
};

export const selectAuthState = createFeatureSelector<AppState, AuthState>('auth');
export const selectResearchesState = createFeatureSelector<AppState, ResearchesState>('researches');
export const selectClientState = createFeatureSelector<AppState, ClientState>('client');

export interface AppState {
  auth: AuthState;
  researches: ResearchesState;
  client: ClientState;
  router: fromRouter.RouterReducerState<any>;
}
